import { StateService } from '@uirouter/angular';
import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';
import { ProjectService } from '../../../services/project.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { UiService } from '../../../services/core.ui.service';

import { scaleTime } from 'd3-scale';
import { timeFormat } from 'd3-time-format';

@Component({
  selector: 'project-activity-chart',
  template: require('./project.activity.chart.component.html'),
})
export class ProjectActivityChartComponent implements OnInit {
  @Input() project: any;
  @Input() readOnly: any;
  @Input() showHeader: any;

  activityChartOptions: any;
  activityStats: any[] = [];
  details: any;

  activityDateChoices: any;
  selectedDateChoice: any;

  constructor(
    private projectService: ProjectService,
    private stateService: StateService,
    private uiService: UiService,
    private gfTranslateService: GfTranslateService
  ) {
    this.activityDateChoices = [
      {
        label: gfTranslateService.translate("This Week"),
        value: 7
      },
      {
        label: gfTranslateService.translate("Last 15 days"),
        value: 15
      },
      {
        label: gfTranslateService.translate("Last 30 days"),
        value: 30
      },
      {
        label: gfTranslateService.translate("Last 90 days"),
        value: 90
      },
      {
        label: gfTranslateService.translate("Last 365 days"),
        value: 365
      },
      {
        label: gfTranslateService.translate("All Time"),
        value: 10000
      },
    ];
  }

  ngOnInit() {
    this.activityChartOptions = {
      chart: {
        type: 'lineChart',
        height: 180,
        margin: {
          top: 1,
          right: 1,
          bottom: 1,
          left: 1,
        },
        showLegend: false,
        useInteractiveGuideline: true,
        x: (d) => d.x,
        y: (d) => d.y,
        lines: {
          xScale: scaleTime(),
        },
        xAxis: {
          tickFormat: (d) => timeFormat('%Y-%m-%d')(d),
        },
        showXAxis: false,
        showYAxis: false,
        transitionDuration: 1000,
      },
    };

    this.setActivityChartDisplay(this.activityDateChoices[0].value);
  }

  getActivityStats(data: any[]) {
    const vals = [];

    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        const dt = new Date(data[i].statDate + 'T00:00:00');
        const ticks = dt.getTime() + dt.getTimezoneOffset() * 60000;
        const dpoint = {
          x: new Date(ticks),
          y: parseInt(data[i].measure),
        };
        vals.push(dpoint);
      }
    }

    const key = this.gfTranslateService.translate('Project Activity');
    return [
      {
        values: vals,
        key: key,
        color: 'rgba(152, 223, 138, .5)',
        area: true,
      },
    ];
  }

  setActivityChartDisplay(choice: any) {
    if (this.selectedDateChoice == choice) return false;

    this.selectedDateChoice = choice;

    const today = new Date();
    today.setDate(today.getDate() - parseInt(this.selectedDateChoice));
    const filterdate = timeFormat('%Y-%m-%d')(today);

    this.activityStats = [];

    this.projectService.activity(this.stateService.params.unixName, {
      start: filterdate,
    })
    .then(
      (response) => {
        this.activityStats = this.getActivityStats(_.get(response, 'items', []));
      },
      (error) => {
        this.activityStats = [];
        if (error.status === 401) {
          return;
        }
        const msg = this.gfTranslateService.translate(
          'There was a problem loading the activity stats for {{unixName}}. You can keep working, but the chart data may not be accurate.',
          { unixName: this.details.unixName }
        );
        this.uiService.message.showWarning(msg, 'Data Error');
      }
    );
  }
}
